import { useEffect } from "react";
import { useSearchParams } from "react-router-dom";

export function useFocusParam(keys) {
  const [params] = useSearchParams();
  return Object.fromEntries(keys.map((k) => [k, params.get(k) || ""]));
}

export function useScrollTo(id, ready) {
  useEffect(() => {
    if (!id || !ready) return;
    const el = document.querySelector(`[data-focus-id="${id}"]`);
    if (el) el.scrollIntoView({ behavior: "smooth", block: "center" });
  }, [id, ready]);
}
